import gql from 'graphql-tag';

const query = gql`
  query getEventsAttendeeExportUrl {
    viewer {
      id
      heAccount {
        id
        amEventsAttendeeExportUrl
      }
    }
  }
`;

export default query;
